import api from "../../../core/api";
import { TrackingSession } from "../trackingSlice";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

export interface StartTrackingDto {
  offerId: string;
  currentLat?: number;
  currentLng?: number;
  destinationLat?: number;
  destinationLng?: number;
  initialEtaMinutes?: number;
}

export interface UpdatePositionDto {
  latitude: number;
  longitude: number;
  accuracy?: number;
  speed?: number;
  heading?: number;
}

class TrackingApi {
  getActiveSessions(): Promise<TrackingSession[]> {
    return api
      .get<TrackingSession[]>(`/v1/customer/tracking/active`, getRequestConfig())
      .then((x) => x.data);
  }

  getSession(sessionId: string): Promise<TrackingSession> {
    return api
      .get<TrackingSession>(
        `/v1/customer/tracking/${sessionId}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  startTracking(dto: StartTrackingDto): Promise<TrackingSession> {
    return api
      .post<TrackingSession>(
        `/v1/customer/tracking/start`,
        dto,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  updatePosition(
    sessionId: string,
    dto: UpdatePositionDto
  ): Promise<any> {
    return api
      .post(
        `/v1/customer/tracking/${sessionId}/position`,
        dto,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  markArrived(sessionId: string): Promise<TrackingSession> {
    return api
      .post<TrackingSession>(
        `/v1/customer/tracking/${sessionId}/arrived`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  pauseTracking(sessionId: string): Promise<TrackingSession> {
    return api
      .post<TrackingSession>(
        `/v1/customer/tracking/${sessionId}/pause`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  resumeTracking(sessionId: string): Promise<TrackingSession> {
    return api
      .post<TrackingSession>(
        `/v1/customer/tracking/${sessionId}/resume`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  endTracking(sessionId: string): Promise<TrackingSession> {
    return api
      .post<TrackingSession>(
        `/v1/customer/tracking/${sessionId}/end`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }
}

export default new TrackingApi();
